import { IonContent, IonModal } from '@ionic/react';
import React from 'react';
import { useSettings } from '../../contexts/SettingsContext';
import useWindowSize from '../../hooks/window-size';

interface BottomSheetProps {
  children: React.ReactNode;
  firstBreakpointPixels: number;
}

const BottomSheet: React.FC<BottomSheetProps> = ({ children, firstBreakpointPixels }) => {
  const content = React.useRef<HTMLIonContentElement>(null);
  const [isDocked, setIsDocked] = React.useState<boolean>(true);
  const { height: windowHeight } = useWindowSize();

  const breakpoints = React.useMemo(() => {
    return [firstBreakpointPixels / windowHeight, 1.0];
  }, [windowHeight]);

  const { marker } = useSettings();

  const bottomSheetCss = {
    self: {
      ['::part(content)']: {
        boxShadow: '0px -4px 8px rgba(0, 0, 0, 0.2)',
      },
    },
  };

  const onBreakpointChange = React.useCallback(
    ({ detail: { breakpoint } }: { detail: { breakpoint: number } }) => {
      setIsDocked(breakpoint === breakpoints[0]);
    },
    [content]
  );

  // Scroll to top when docked
  React.useEffect(() => {
    if (isDocked) {
      content.current?.scrollToTop(500); // smooth scroll
    }
  }, [isDocked]);

  return (
    <IonModal
      isOpen={!!marker}
      initialBreakpoint={breakpoints[0]}
      breakpoints={breakpoints}
      backdropDismiss={false}
      backdropBreakpoint={0.75}
      animated={false}
      css={bottomSheetCss.self}
      onIonBreakpointDidChange={onBreakpointChange}
      onIonModalDidDismiss={() => setIsDocked(true)}
    >
      <IonContent ref={content} className="bottom-sheet" scrollY={!isDocked}>
        {children}
      </IonContent>
    </IonModal>
  );
};

export default BottomSheet;
